import React from 'react';

const Header = () => {

    return(
        <div className="header columns">
            <div className="column">
                <h1 id="title">
                    Random Geometry-Algebra Word Problem Generator
                </h1>
                <h2>
                    Practice understanding perimeter, area, surface area, volume, and more! Educational math tool by <a href="http://pioslabs.com/">Pios Labs</a>.
                </h2>
                <h3>
                    
                </h3>            
            </div>
        </div>
    );

};

export default Header;